var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},[_c('p',[_vm._v("© สำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร 77/1 ถนนพระรามที่ 6 แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400 โทรศัพท์ 023546858 (เบอร์กลาง) โทรสาร 023546842 \n\t\t\t  "),_c('i',{staticClass:"pi pi-phone"}),_vm._v(" สายด่วน 199")])])
}]

export { render, staticRenderFns }